<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Credito_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Consulta de Análise de Crédito</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>Na hora de avaliar o potencial dos seus clientes, você precisa ter a certeza de estar acessando dados
              confiáveis e com base em critérios parametrizados. Burocracia e soluções demoradas? Aqui não.</p>
            <p>O mais completo banco de dados da América Latina em informações de crédito de pessoas físicas e
              jurídicas. Tudo o que você precisa para tomar as melhores decisões e evitar surpresas desagradáveis lá na
              frente.</p>
          </div>
        </div>
        <div class="right">
          <figure class="fig">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Consulta-credito@2x.png">
          </figure>
        </div>
      </div>

    </div>
  </section>


  <app-contact-box></app-contact-box>

</main>
